var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.notFoundMessage
        ? _c("PageNotFound", {
            attrs: { message: _vm.notFoundMessage },
            on: { onClick: _vm.handleClick, onDispose: _vm.handleDispose }
          })
        : _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }